/* eslint-disable react-hooks/exhaustive-deps */

import { withStyles } from '@material-ui/core';

import { Box, Grid } from '@mui/material';

import { compose } from 'recompose';
import { connect } from 'react-redux';
import React from 'react';
import VisaPermitCard from './visaPermitCard.component';
import ImmunizationCard from './immunizationCard.component';

const styles = theme => ({
  card: {
    width: '100%',
    maxWidth: 1500,
    flexGrow: 1,
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  cardContainer: {
    maxWidth: '100% !important',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between'
  },
  iconRow: {
    display: 'flex',
    flexDirection: 'row'
  },
  dialogIconRow: {
    display: 'flex',
    flexDirection: 'row',
    padding: '40px',
    paddingBottom: '20px'
  },
  cardDisplayContent: {
    maxWidth: '100% !important',
    display: 'flex',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'space-between',
    margin: '10px'
  }
});

export const ZERO_GUID = '00000000-0000-0000-0000-000000000000';

export const toNumberOrNull = v => {
  const n = Number(v);
  return Number.isFinite(n) ? n : null;
};

export const toDateOrNull = v => {
  if (!v) return null;
  const d = new Date(v);
  return isNaN(d.getTime()) ? null : d.toISOString().split('T')[0];
};

export const toGuidOrZero = v => (typeof v === 'string' && v.length === 36 ? v : ZERO_GUID);
export const toStringOrEmpty = v => (v ?? '').toString().trim();

const VisaTab = props => {
  const { details, id, familyMemberId, isReadOnly, enumerations } = props;
  const visaAndVaccineInfo = details?.global?.visaAndVaccinationInfo || [];
  const selectedInfo = visaAndVaccineInfo.find(f => f.familyMemberId === familyMemberId) || { familyMemberId: familyMemberId };
  const globalId = details?.global?.globalInfo?.globalAssignmentId;

  return (
    <Box>
      <Grid container rowSpacing={2} columnSpacing={{ xs: 1, sm: 2, md: 2 }}>
        <Grid item xs={12} xl={6} rowSpacing={2}>
          <VisaPermitCard
            globalInfo={selectedInfo}
            authId={id}
            familyMemberId={familyMemberId}
            isReadOnly={isReadOnly}
            enumerations={enumerations}
            globalId={globalId}
          />
        </Grid>
        <Grid item xs={12} xl={6} rowSpacing={2}>
          <ImmunizationCard
            globalInfo={selectedInfo}
            authId={id}
            familyMemberId={familyMemberId}
            isReadOnly={isReadOnly}
            enumerations={enumerations}
            globalId={globalId}
          />
        </Grid>
      </Grid>
    </Box>
  );
};

const mapStateToProps = state => {
  return {};
};

export default compose(withStyles(styles), connect(mapStateToProps, {}))(VisaTab);
